import styled from 'styled-components';
import { useMemo } from 'react';
import { Journey } from 'modules/domains/campaign';
import { spacing } from 'ui/theme';
import { LightText } from './Sections.styled';

export const JOURNEY_NODE_ID = 'journey-node-id';

export const StyledLightText = styled(LightText)`
  margin-top: ${spacing.quarter};
  display: inline-flex;
`;

const getCampaignJourneyNode = (campaignId: number, journey?: Journey) =>
  journey?.allNodes?.find((n) => n?.resource?.campaign?.id === campaignId);

export const JourneyNodeId = ({
  journey,
  campaignId,
}: {
  journey?: Journey;
  campaignId: number;
}) => {
  const node = useMemo(() => getCampaignJourneyNode(campaignId, journey), [campaignId, journey]);
  return <StyledLightText>Tile ID {node?.id}</StyledLightText>;
};
